import { render } from "./인공신장센터.vue?vue&type=template&id=bfbd0c92"
import script from "./인공신장센터.vue?vue&type=script&lang=js"
export * from "./인공신장센터.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__